"use strict";
var index_1 = require("./index");
exports.dragula = index_1.dragula;
exports.DragulaDirective = index_1.DragulaDirective;
exports.DragulaModule = index_1.DragulaModule;
exports.DragulaService = index_1.DragulaService;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-dragula/ng2-dragula.js
// module id = 998
// module chunks = 3